import { cn } from '@discover-lib/utils';
import { forwardRef } from 'react';

export type ScrollContainerProps = React.ComponentPropsWithoutRef<'div'>;

const ScrollContainer = forwardRef<HTMLDivElement, ScrollContainerProps>(
  ({ className, ...props }, ref) => (
    <div
      className={cn(
        'no-scrollbar flex max-w-full flex-row items-start gap-1.5 overflow-x-auto px-3 sm:gap-1 lg:px-0',
        className
      )}
      {...props}
      ref={ref}
    />
  )
);

ScrollContainer.displayName = 'ScrollContainer';

export default ScrollContainer;
